import "./utils/ready";
import $ from "jquery";

document.ready().then(function () {
  // JS to run globally

  // Initialize Foundation
  window.jQuery(document).foundation();

  // Mobile nav toggle
  $("#nav-mobile-toggle").on("click", function () {
    $("#nav-mobile").slideToggle();
  });

  // let videoButton = document.querySelector('.video--js')
  // if(videoButton) {
  //   videoButton.addEventListener('click', () => {
  //     videoButton.style.opacity = 0;
  //     videoButton.style.pointerEvents = 'none';

  //     let parent = videoButton.parentNode
  //     let video = parent.querySelector('video')
  //     if(video) {
  //       video.play()
  //     }
  //   })
  // }
});
